<template>
  <div id="notification">
    <v-layout>
      <v-card style="width:100%;">
          <v-toolbar dark color="white">
            <v-btn small icon dark @click="$router.push('/')">
              <v-icon style="color:#10AA85;">arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title style="color:#10AA85">Notifikasi</v-toolbar-title>
          </v-toolbar>
      </v-card>
    </v-layout>

    <v-container>
      <v-layout text-xs-center v-if="items.length < 1">
        <v-flex xs12>
          <img src="@/assets/icon/empty-notif.svg" alt="empty-icon" style="margin:25px;">
          <p>Maat, tidak ada notifikasi untuk saat ini</p>
        </v-flex>
      </v-layout>
      <v-card v-if="items.length > 0" style="border-radius:8px;">
        <v-layout row wrap v-for="(item, index) in items" :key="index" @click="toggle(index, item)" class="lay-notif">
          <v-flex xs11>
              <h3> {{ item.payload.data.title }}</h3>
              <h4 style="font-weight:400;line-height:25px;">{{ item.payload.data.body }}</h4>
              <span>{{item.payload.time | toDate}}</span>
          </v-flex>
          <v-flex xs1 v-if="!item.payload.isRead" style="display:flex; justify-content:center; align-items:center;">
              <img src="@/assets/icon/unread.svg" alt="unread-icon">
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>
<style>
#notification {
  background-color:white;
  min-height: 100vh;
}

.lay-notif {
  padding:13px;cursor:pointer;
}

.lay-notif:hover{
  background:#c2c2c2;
}
</style>
<script>
import moment from 'moment/src/moment'
export default {
  name: 'notification',
  data () {
    return {
      selected: [2],
      items: [],
      db: [],
      notif: []
    }
  },
  filters: {
    relativeTime (value) {
      moment.locale('en')
      return moment(value).fromNow()
    },
    toDate (value) {
      moment.locale('en')
      return moment(value).format('DD/MM/YYYY')
    }

  },
  methods: {
    toggle: async function (index, value) {
      value.payload.isRead = true
      var data = JSON.parse(value.payload.data.payload)
      await this.updateNotifToDb(value)
      if (value.payload.data.channel === 'CHANNEL_PAYMENT') this.$router.push('/payment-status/' + data.id + '/n')
      if (value.payload.data.channel === 'CHANNEL_REFERRAL') this.$router.push('/friend-referral')
    },
    async getDb () {
      return new Promise((resolve, reject) => {
        let request = window.indexedDB.open('juaraNotif', 1)

        request.onerror = e => {
          // console.log('Error opening db', e)
          reject('Error')
        }

        request.onsuccess = e => {
          resolve(e.target.result)
        }

        request.onupgradeneeded = e => {
          // console.log('onupgradeneeded');
          let db = e.target.result
          let objectStore = db.createObjectStore('juaraNotif', { keyPath: 'ssn' })
        }
      })
    },
    async updateNotifToDb (notif) {
      let context = this
      const customerData = {
        ssn: notif.ssn,
        payload: JSON.stringify(notif.payload)
      }
      return new Promise((resolve, reject) => {
        let trans = context.db.transaction(['juaraNotif'], 'readwrite')
        trans.oncomplete = e => {
          resolve()
        }

        let store = trans.objectStore('juaraNotif')
        store.put(customerData)
      })
    },
    async getNotifFromDB () {
      let context = this
      return new Promise((resolve, reject) => {
        let trans = this.db.transaction(['juaraNotif'], 'readonly')
        trans.oncomplete = e => {
          resolve(notif)
        }
        let store = trans.objectStore('juaraNotif')
        let notif = []
        let psh = []
        store.openCursor().onsuccess = e => {
          let cursor = e.target.result
          if (cursor) {
            notif = cursor.value
            if (cursor !== null) {
              var iid = JSON.parse(notif.payload)
              var uid = JSON.parse(iid.data.payload)
              if (uid.user_id === parseInt(sessionStorage.getItem('UID'))) {
                psh.push(notif)
              }
              sessionStorage.setItem('notification', JSON.stringify(psh))
            }
            cursor.continue()
          }
        }
        context.loaderNotif()
      })
    },
    loaderNotif () {
      var notification = []
      if (sessionStorage.getItem('notification')) {
        var listnotif = JSON.parse(sessionStorage.getItem('notification'))
        for (var i = 0; i < listnotif.length; i++) {
          var parsed = JSON.parse(listnotif[i].payload)
          listnotif[i].payload = parsed
          listnotif[i].time = parsed.time
          notification.push(listnotif[i])
        }
        this.items = notification
        this.items.sort(function (a, b) {
          // return (a.time > b.time) ? -1 : ((a.time > b.time) ? 1 : 0)
          return new Date(b.time).getTime() - new Date(a.time).getTime()
        })
      }
    }
  },
  created: async function () {
    this.db = await this.getDb()
    this.notif = await this.getNotifFromDB()
    this.loaderNotif()
  }
}
</script>
